import React from "react"
import {graphql, StaticQuery, Link} from 'gatsby'

const Category = () => (
    <StaticQuery query={graphql`
        {
            allWordpressCategory(filter: {name: {nin: "Ukategorisert"}}) {
                edges {
                    node {
                    id
                    slug
                    name
                    count
                    }
                }
            }
        }
      
    `} render={props => (

      <div>
        <h4 className="font-weight-bold">Kategorier</h4>
        <ul className="list-group">
            {props.allWordpressCategory.edges.map(post => (
            <div key={post.node.id}>
                
                <Link to={`/kategori/${post.node.slug}`} className="list-group-item d-flex justify-content-between align-items-center">
                    {post.node.name}
                    <span class="badge badge-primary badge-pill">{post.node.count}</span>
                </Link>
                
            </div>
            ))}
        </ul>
      </div>

    )} />
)

export default Category;